import getBarData from './barData';
import getLineData from './lineData';
import getPieData from './pieData';
import mAphorism from '../components/mAphorism.vue'
import mChart from '../components/mChart.vue';
import mCircularProgress from '../components/mCircularProgress.vue'
import mCourseTab from '../components/mCourseTab.vue';
import mLineProgress from '../components/mLineProgress.vue'
import mNotesAndDiscussions from '../components/mNotesAndDiscussions.vue';
import mOpeningStatus from '../components/mOpeningStatus.vue'
import mRankingList from '../components/mRankingList.vue';
import mSelects from '../components/mSelects.vue';
import mSlideSwitch from '../components/mSlideSwitch.vue';
import mStatistics from '../components/mStatistics.vue';
import mSwitch from '../components/mSwitch.vue';
import mTitle from '../components/mTitle.vue';

export default {
  components: {
    mTitle,
    mCourseTab,
    mSwitch,
    mSlideSwitch,
    mChart,
    mStatistics,
    mSelects,
    mRankingList,
    mLineProgress,
    mCircularProgress,
    mNotesAndDiscussions,
    mAphorism,
    mOpeningStatus,
  },
  data() {
    return {
      userType: sessionStorage.getItem('userType'),
      userId: sessionStorage.getItem('userId'),
      tipText: '该模块从2023年1月10日开始，只统计数字课程与实践教学的情况',
      testTipText: '该模块只统计数字课程中的测验，暂不包括测评考试',
      tipStyle: {right: '24%', top: '15%'},
      currentSwitchTime: null,
      fromData: {}
    }
  },
  methods: {
    async weekMonthChange(item, func) {
      if (this.fromData.courseId == null)return;
      this.currentSwitchTime = item
      if (item && item.time != null) {
        const date = await new Date()._$getServerTime()
        const month = item.time === 30 ? -1 : 0
        const day = item.time === 7 ? -7 : 0
        const startDate = date._$skipTime(0, month, day)._$formatDate(date._$formats.enAsDate)
        const endDate = date._$formatDate(date._$formats.enAsDate)
        func && await func(startDate, endDate)
      } else {
        func && await func()
      }
    },
    /**
     * 处理分数显示不全问题
     * @param data
     * @param maxScore
     */
    setFractionYAxisMax(data = {},maxScore = 0){
      if (maxScore == null){
        data.yAxis.max = null
        data.yAxis.min = null
      }else {
        const num = maxScore % 10
        data.yAxis.max = maxScore < 100 ? 100 : num > 0 ? maxScore + (10 - num) : maxScore
        data.yAxis.min = 0
      }
    }
  }
}

export {
  getBarData,
  getLineData,
  getPieData
}



// WEBPACK FOOTER //
// ./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/mixins/index.js